<template>
	<div class="page_content module_page" aria-label="Major Minor Edit Page">

	<div class="hidden-container">
		<form method="POST" id="multipleFileUploadForm" enctype="multipart/form-data" v-on:submit.prevent>
			<input type="file" id="thumbnailFileList" ref="thumbnailFileList" name="thumbnailFile" @change="thumbnailToBeUploaded" />
		</form>
	</div>

	<div class="row page-heading">
		<div class="col-8 input module_heading">
        	<span class="module_icon ic-majorMinor"></span>
        	<label class="head_txt module_type_name">{{this.name}}</label>
      	</div>
      	<div class="col-4 btn_container">
			<button :class="{disabled: !majorMinorDataIsValid}" class="btn btn-primary" @click.stop="onSubmit(true)" :disabled="submitted" aria-label="done">done</button>
			<button :class="{disabled: !majorMinorDataIsValid}" class="btn btn-primary" @click.stop="onSubmit(false)" aria-label="save">save</button>
			<button class="btn-cancel" @click="cancelClicked" title="Cancel"><span class="icon-cross"></span></button>
      	</div>
    </div>


    <div class="page-content">

		<div class="col-12 dasboard-left-section">
	    	<div class="row">
	        	<div class="col-12 pg_fld_sec">


		      		<div class="row pg_fld_row">

						<div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
							<div class="fld_label">
								<label class="label" for="majorMinorName">Name</label>
								<span class="fld_req">*</span>
							</div>
							<div class="fld_input">
		    					<input id="majorMinorName" v-model="name">
							</div>
						</div>

						<div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
							<div class="fld_label">
								<label class="label" for="majorMinorCode">Program Guide Code</label>
							</div>
							<div class="fld_input">
		    					<input id="majorMinorCode" v-model="code">
							</div>
						</div>

		      		</div>


		      		<div class="row pg_fld_row">

						<div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
		      				<div class="fld_label">
		      					<label class="label" for="majorMinorCipCode">CipCode</label>
		      					<span class="fld_req">*</span>
		      				</div>
		      				<div class="fld_input">
		      					<input id="majorMinorCipCode" v-model="cipCode">
		      				</div>
		      			</div>

		      			<div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
		      				<div class="fld_label">
		      					<label class="label" for="majorMinorRelatedCipCodes">Related Cip Codes</label>
		      				</div>
		      				<div class="fld_input">
		      					<input id="majorMinorRelatedCipCodes" v-model="relatedCipCodes">
		      				</div>
		      			</div>

		      		</div>


		      		<div class="row pg_fld_row">

						<div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">

							<div class="row">
								<div class="col-12">
									<div class="fld_label">
										<label class="label" for="majorMinorCategory">Category</label>
									</div>
									<div class="fld_input">
				    					<input id="majorMinorCategory" v-model="category">
									</div>
								</div>
							</div>

							<div class="row" style="margin-top: 30px;">
				      			<div class="col-12">
				      				<div class="fld_label">
				      					<label class="label" for="majorMinorSubCategory">Sub-Category</label>
				      				</div>
				      				<div class="fld_input">
				      					<input id="majorMinorSubCategory" v-model="subCategory">
				      				</div>
				      			</div>
				      		</div>

				      		<div class="row" style="margin-top: 30px;">
					      		<div class="col-12">
									<div class="fld_label">
										<label class="label" for="majorMinorType">Type</label>
									</div>
									<div class="fld_input">
				    					<input id="majorMinorType" v-model="type">
									</div>
								</div>
							</div>

						</div>

						<div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
		      				<div class="fld_label">
		      					<label class="label">Update Thumbnail</label>
		      				</div>
		      				<div class="fld_input">
								<div class="thumbnail_container d-flex" style="height: 271px;">
            						<img v-if="thumbnailURI" id="majorMinorThumbnail" :src="thumbnailURI">
            						<span v-else class="ic ic-majorMinor" style="font-size: 98px; height: 98px;"></span>
            						<b-btn @click="addThumbnailClicked">edit thumbnail</b-btn>
          						</div>
		      				</div>
		      			</div>

		      		</div>


	        	</div> <!-- .pg_fld_sec -->
	        </div> <!-- .row -->
		</div> <!-- .dasboard-left-section -->

	</div> <!-- .page-content -->



                      <div>

                      <b-modal ref="modal" id="addNewThumbnail" v-model="showAddThumbnailModal" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered class="modal_popup popup_add_thumbnail">
                                <div slot="modal-header" class="popover-header">
								  <div class="popup-heading">Update Thumbnail</div>
									<button class="btn_close" aria-label="close" @click="cancelAddThumbnail">
									   <span class="ic-close"></span>
									</button>
								</div>
                              <div class="row">

                                <div class="col-4">
                                  <div class="thumbnail_msg">How your thumbnail will appear</div>
                                  <div class="thumbnail_container">
																		<b-btn v-if="isUploadingThumbnail || (thumbnailURI && thumbnailURI.length > 0)" @click.stop="removeThumbnailClicked" class="btn">remove thumbnail</b-btn>
                                    <img v-if="thumbnailURI" id="majorMinorThumbnail" :src="thumbnailURI">
																		<span v-else class="ic ic-majorMinor" style="font-size: 98px; height: 98px;"></span>
                                  </div>
                                </div>


                                 <div class="col-7 right-model-box">

                                  <div class="row fld_row">
                                    <div class="col-1 fld_col_label">
                                      <label>URL</label>
                                    </div>
                                    <div class="col-8 fld_col_input">
                                      <input :id="newThumbnailUrl" :disabled="isUploadingThumbnail" v-model="thumbnailURI" placeholder="http://"></input>
                                    </div>
                                    <div class="col-3 btn_container">
                                    </div>
                                 </div>


                                 <div class="row fld_row msg_row">
                                    <div class="col-1"></div>
                                    <div class="col-11 msg">Add image url for thumbnail.</div>
                                  </div>
                                  <div class="row txt_sep_row">
                                    <div class="col-12">OR</div>
                                 </div>


                                 <div class="row fld_row">
                                    <div class="col-1 fld_col_label">
                                      <label for="newThumbnailFileName">File</label>
                                    </div>
                                    <div class="col-8 fld_col_input">
                                      <input id="newThumbnailFileName" disabled v-model="logo" placeholder="choose a file from your computer"></input>
                                    </div>
                                    <div class="col-3 fld_col_btn">
                                      <b-btn :disabled="isUploadingThumbnail" @click.stop="chooseFile(true)">add file</b-btn>
                                    </div>
                                  </div>


                                  <div class="row msg_row">
                                    <div class="col-1"></div>
                                    <div class="col-11 msg">Select a jpg, jpeg, bmp, gif or png file.</div>
                                  </div>
                                </div>
                              </div>

                              <div slot="modal-footer">
                                <b-btn @click="addNewThumbnail">save and next</b-btn>
                                <b-btn @click="cancelAddThumbnail">cancel</b-btn>
                              </div>

                            </b-modal>

                        </div>

	</div>
</template>

<script>
  /* global AWS:true */
  import { mapState, mapActions } from 'vuex'
  import _ from 'lodash'
  import { AwsObject } from '../aws'

  var getFileName = function (fileName) {
    if (!fileName && fileName !== null) {
      return null
    }
    return fileName.replace(/\.\w+$/g, '')
  }

  var getUpdatedFileName = function (title, fileName) {
    var ext = fileName.substr((~-fileName.lastIndexOf('.') >>> 0) + 2)
    if (ext !== '' || ext !== null) {
      return (title + '.' + ext)
    } else {
      return fileName
    }
  }

  var FileObject = function (title, file, size, timestamp, type) {
    console.log('creating file: ', file)
    this.title = getFileName(title)
    this.file = file
    this.fileName = getUpdatedFileName(this.title, title)
    this.size = size
    this.contentFileType = type
    this.timestamp = timestamp
    this.id = timestamp
    // added
    // this.uri = file.uri
  }

  var clone = function (obj) {
    if (obj === null || typeof obj !== 'object') return obj
    var copy = obj.constructor()
    for (var attr in obj) {
      if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr]
    }
    return copy
  }

  export default {
    name: 'major-minor-edit',
    props: ['cipCode', 'code'],
    components: {
    },
    data: () => {
      return {
        userId: {},
        uuid: '',
        code: '',
        name: '',
        relatedCipCodes: '',
        category: '',
        subCategory: '',
        thumbnailURI: '',
        thumbnail: '',
        thumbnailURICopy: '',
        thumbnailCopy: '',
        showAddThumbnailModal: false,
        fileUploadArray: [],
        errors: [],
        owningLibrary: {},
        isEditingThumbnail: false
      }
    },
    created () {
      window.addEventListener('unload', this.goToListPage)
    },
    mounted () {
      // TODO detect page refresh and route back to detail
      const userId = localStorage.getItem('userid')
      this.loadLibrariesForUser(userId).then(learningSpaces => {
        this.folders = []
        for (var i = 0; i < learningSpaces.length; i++) {
          const learningSpace = learningSpaces[i]
          const permission = learningSpace.acelist[0].permission
          if (permission && permission.folderPermission && permission.folderPermission.allowedAsDestinationFolder) {
            this.folders.push(learningSpace)
            if (learningSpace.category === 'Institute_Public') {
              this.owningLibrary = {uuid: learningSpace.uuid, displayName: learningSpace.displayName}
            }
          }
        }
        if (this.folders.length > 0 && _.isEmpty(this.owningLibrary)) {
          this.owningLibrary = {uuid: this.folders[0].uuid, displayName: this.folders[0].displayName}
        }
      })
      this.loadCurrentEnvironment().then(res => {
        AwsObject(res)
      })
      this.loadDataForMajorMinorDetail()
    },

    methods: {
      ...mapActions([
        'loadMajorMinor',
        'storeMajorMinor',
        'loadLibrariesForUser',
        'uploadContentAndGetUri',
        'updateFileUriAndVersionIdAfterS3Upload',
        'loadCurrentEnvironment'
      ]),
      goToListPage () {
        this.$router.push({ name: 'majorMinorList' })
      },
      loadDataForMajorMinorDetail () {
        this.loadMajorMinor({ code: this.code }).then(response => {
          this.uuid = response.uuid.slice(0)
          this.thumbnailURI = (response.thumbnailURI) ? response.thumbnailURI.slice(0) : ''
          this.type = response.type
          this.code = response.code
          this.name = response.name
          this.relatedCipCodes = (response.relatedCipCodes && response.relatedCipCodes.length > 0) ? response.relatedCipCodes.join(', ') : []
          this.category = response.category
          this.subCategory = response.subCategory
        })
      },
      majorMinorDataIsValid () {
        if (this.name && this.cipCode) {
          return true
        } else {
          this.errors.push('Error: MajorMinor name and cipCode cannot be blank')
        }
        return false
      },
      onSubmit (isDone) {
        if (!this.majorMinorDataIsValid()) {
          this.$notify({
            group: 'notify',
            type: 'error',
            title: '',
            text: this.errors.join('\n')
          })
          this.errors = []
          return
        }
        this.submitted = true

        const majorMinorData = {
          uuid: this.uuid,
          type: this.type,
          cipCode: this.cipCode,
          relatedCipCodes: this.relatedCipCodesForSaving,
          code: this.code,
          name: this.name,
          category: this.category,
          subCategory: this.subCategory,
          thumbnailURI: this.thumbnailURI
        }
        this.storeMajorMinor(majorMinorData).then(response => {
          if (isDone) {
            return this.$router.push({ name: 'majorMinorList' })
          } else {
            this.$notify({
              group: 'notify',
              type: 'success',
              title: '',
              text: 'MajorMinor "' + this.name + '" updated successfully.'
            })
            this.submitted = false
          }
        })
      },
      addThumbnailClicked () {
        this.showAddThumbnailModal = true
        // this.isEditingThumbnail = true
        this.thumbnailURICopy = this.thumbnailURI.slice(0)
        this.thumbnailCopy = this.thumbnail.slice(0)
      },
      removeThumbnailClicked () {
        this.isEditingThumbnail = true
        this.thumbnailURI = ''
        this.thumbnail = ''
      },
      cancelAddThumbnail () {
        this.thumbnailURI = this.thumbnailURICopy
        this.thumbnail = this.thumbnailCopy
        this.isEditingThumbnail = false
        this.showAddThumbnailModal = false
        this.errors = []
        this.fileUploadArray = []
      },
      addNewThumbnail () {
        if (this.thumbnail !== this.thumbnailURI) {
          // user entered url instead of uploading local file, no upload necessary
          this.thumbnail = this.thumbnailURI
        } else {
          this.uploadFiles('thumbnail')
        }
        this.showAddThumbnailModal = false
        this.isEditingThumbnail = false
      },
      chooseFile () {
        $('input[type=file][id=thumbnailFileList]').click()
      },
      thumbnailToBeUploaded (ev) {
        this.fileUploadArray = []
        var files = ev.target.files || ev.dataTransfer.files
        if (!files.length || files.length <= 0) {
          return
        }
        this.thumbnailURI = files[0].name
        this.thumbnail = files[0].name
        this.prepareFileUploadArray(files)
      },
      prepareFileUploadArray (files) {
        if (files) {
          console.log('files: ', files)
          var timestamp = new Date().getTime()
          for (var i = 0; i < files.length; i++) {
            timestamp = timestamp + i
            this.addFileToUploadArray(files[i], timestamp)
          }
        }
      },
      addFileToUploadArray (newFile, timestamp) {
        var isFound = _.find(this.fileUploadArray, function (file) {
          return ((newFile.name === file.title) && (newFile.size === file.size))
        })

        if (!isFound) {
          this.fileUploadArray.push(new FileObject(newFile.name, newFile, newFile.size, timestamp, newFile.type))
        }
        console.log('new fileUploadArray: ', this.fileUploadArray)
      },
      uploadFiles (contentType) {
        let fileUploadArrayClone = clone(this.fileUploadArray)
        let contentListToCreate = []
        for (var i = 0; i < fileUploadArrayClone.length; i++) {
          let content = fileUploadArrayClone[i]
          console.log('creating content item: ', content)
          let item = {
            'title': content.title,
            'lastModifiedDate': content.contentFileType.timestamp,
            'contentFileType': content.contentFileType,
            'fileName': content.fileName,
            'timestamp': content.timestamp,
            'thumbnail': content.thumbnail,
            'thumbnailURI': content.thumbnailURI
          }
          contentListToCreate.push(item)
        }
        if (contentListToCreate.length <= 0) {
          return
        }
        this.uploadContentAndGetUri({
          learningSpaceId: this.owningLibrary.uuid,
          contents: contentListToCreate,
          success: this.uploadFileAfterCreateContentSuccessCallback,
          failure: this.uploadFileAfterCreateContentErrorCallback
        })
      },
      cancelClicked () {
        return this.$router.push({ name: 'majorMinorList' })
      },
      uploadFileAfterCreateContentSuccessCallback (response) {
        var createdContents = response.createdContents
        if (createdContents.length > 0) {
          // uploading files on S3 for created contents
          var fileUploadArrayClone = clone(this.fileUploadArray)
          this.uploadLearningContentFilesOnS3(createdContents, fileUploadArrayClone)
        }
        this.fileUploadArray = []
        this.showSuccessPopup()
      },
      uploadFileAfterCreateContentErrorCallback (response) {
        console.log('Error occured while creating content(s) ', response)
      },
      uploadLearningContentFilesOnS3 (createdContents, fileUploadArrayClone) {
        var filesToBeUploaded = []
        $.each(createdContents, (index, content) => {
          for (var i = 0; i < fileUploadArrayClone.length; i++) {
            var fileData = fileUploadArrayClone[i]
            if (content.fileName === fileData.fileName) {
              var key = content.uuid + '-' + content.fileName
              filesToBeUploaded.push({'uuid': content.uuid, 'key': key, 'uri': content.uri, 'fileData': fileData})
              break
            }
          }
        })
        if (filesToBeUploaded.length > 0) {
          this.storeFilesToS3(filesToBeUploaded)
        }
      },
      storeFilesToS3 (filesToBeUploaded) {
        var awsRef = new AWS.S3()
        var s3Bucket = this.currentEnvironment.s3Bucket
        $.each(filesToBeUploaded, (i, item) => {
          var params = {
            Key: item.key,
            Bucket: s3Bucket,
            ContentType: item.fileData.contentFileType,
            ACL: 'public-read',
            Body: item.fileData.file
          }
          awsRef.putObject(params, (err, data) => {
            if (err) {
              console.log('Uploading Learning Content File Failed On S3: ' + err.stack)
            } else {
              var uri = item.uri
              if (uri.indexOf('?versionId=') === -1) {
                uri = uri.concat('?versionId=' + data.VersionId)
                this.updateFileUriAndVersionIdAfterS3Upload({uuid: item.uuid, uri: uri})
              }
            }
            let thumbnailData = filesToBeUploaded[0]
            this.thumbnailURI = thumbnailData.uri
            this.thumbnail = thumbnailData.uri
          })
        })
      },
      showSuccessPopup () {
        console.log('file upload successful!')
      }
    },
    computed: {
      ...mapState({
        'learningSpaces': state => state.assessment.learningSpaces,
        'currentEnvironment': state => state.learningContent.currentEnvironment
      }),
      relatedCipCodesForSaving () {
        let relatedCipCodes = []
        if (!this.relatedCipCodes || !this.relatedCipCodes.length) {
          return []
        }
        this.relatedCipCodes.split(',').forEach(relatedCipCode => {
          relatedCipCodes.push(relatedCipCode.trim())
        })
        return relatedCipCodes
      }
    },
    watch: {

    }
  }
</script>

<style scoped>
.input-group {
  z-index: 2;
}

.hidden-container {
  visibility: hidden;
  height: 1px;
}

.heading {
  font-size: 20px;
}

.tag-container {
	max-height: fit-content !important;
}

.label {
  font-size: 20px;
  font-weight: bold;
}

.lnk_txt {
    margin-left: 42px;
    width: 75%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/app/programguide/components/MajorMinorEdit.vue